import { InputHTMLAttributes, forwardRef, ReactNode } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  status?: 'error' | '';
  /** Optional element rendered on the right (e.g. a password toggle). */
  suffix?: ReactNode;
}

export const inputBase =
  'w-full h-11 rounded-lg border bg-white px-3.5 text-sm text-ink placeholder:text-ink-secondary/60 transition-colors focus:outline-none';

/** Custom text input — replaces antd Input. */
const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { status = '', suffix, className = '', ...rest },
  ref,
) {
  const border =
    status === 'error'
      ? 'border-red-400 focus:border-red-500 focus:ring-2 focus:ring-red-100'
      : 'border-line focus:border-brand focus:ring-2 focus:ring-brand/15';

  if (suffix) {
    return (
      <div
        className={[
          'flex items-center rounded-lg border bg-white pr-2 transition-colors focus-within:ring-2',
          status === 'error'
            ? 'border-red-400 focus-within:border-red-500 focus-within:ring-red-100'
            : 'border-line focus-within:border-brand focus-within:ring-brand/15',
          className,
        ].join(' ')}
      >
        <input
          ref={ref}
          className="h-11 w-full rounded-lg bg-transparent px-3.5 text-sm text-ink placeholder:text-ink-secondary/60 focus:outline-none"
          {...rest}
        />
        {suffix}
      </div>
    );
  }

  return <input ref={ref} className={[inputBase, border, className].join(' ')} {...rest} />;
});

export default Input;
